var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurveyMostlyAutomated({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 121,
    viewBox: "0 0 153 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.601 0h125.605v96.166H.601V0z",
    fill: "#5959EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47 16.682h111.867v72.615H7.47V16.682z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.377 8.832a2.944 2.944 0 1 1-5.888 0 2.944 2.944 0 0 1 5.888 0z",
    fill: "#19D89F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.208 8.832a2.944 2.944 0 1 1-5.887 0 2.944 2.944 0 0 1 5.887 0z",
    fill: "#FED730"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.04 8.832a2.944 2.944 0 1 1-5.888 0 2.944 2.944 0 0 1 5.888 0z",
    fill: "#BF3DC2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.543 48.469c.6.548.641 1.48.093 2.08l-7.185 7.858-4.602-3.48a1.472 1.472 0 1 1 1.775-2.348l2.463 1.862 5.376-5.88c.549-.6 1.48-.64 2.08-.092z",
    fill: "#19D89F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.658 67.158a1.472 1.472 0 0 0 0 2.082l6.87 6.869a1.472 1.472 0 1 0 2.08-2.082l-6.868-6.869a1.472 1.472 0 0 0-2.082 0z",
    fill: "#BF3DC2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.609 67.158a1.472 1.472 0 0 1 0 2.082l-6.87 6.869a1.472 1.472 0 1 1-2.08-2.082l6.868-6.869a1.472 1.472 0 0 1 2.082 0z",
    fill: "#BF3DC2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.38 52.99a4.416 4.416 0 0 1 4.417-4.416h59.858a4.416 4.416 0 1 1 0 8.831H42.797a4.416 4.416 0 0 1-4.416-4.416zM38.38 71.634a4.416 4.416 0 0 1 4.417-4.416h59.858a4.416 4.416 0 1 1 0 8.832H42.797a4.416 4.416 0 0 1-4.416-4.416z",
    fill: "#000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.283 25.513h92.241V38.27h-92.24V25.513z",
    fill: "#19D89F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M152.399 91.07c0 16.53-13.4 29.93-29.93 29.93-16.529 0-29.929-13.4-29.929-29.93 0-16.529 13.4-29.928 29.929-29.928 16.53 0 29.93 13.4 29.93 29.929z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.517 70.177h7.905v3.957c2.33.6 4.478 1.652 6.344 3.058l2.498-2.498 5.59 5.59-2.947 2.948a17.982 17.982 0 0 1 1.499 3.886h3.958v7.906h-3.706a17.93 17.93 0 0 1-1.666 4.85l2.862 2.862-5.59 5.59-2.356-2.355a18.004 18.004 0 0 1-6.486 3.166v3.957h-7.905v-3.705a17.985 17.985 0 0 1-7.111-3.044l-1.981 1.981-5.591-5.59 2.29-2.29a17.935 17.935 0 0 1-1.972-5.422h-3.706v-7.906h3.958a17.947 17.947 0 0 1 1.811-4.453l-2.381-2.38 5.591-5.59 2.128 2.127a17.972 17.972 0 0 1 6.964-2.94v-3.705zm3.388 29.364a7.906 7.906 0 1 0 0-15.812 7.906 7.906 0 0 0 0 15.812z",
    fill: "#BF3DC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyMostlyAutomated);
export default __webpack_public_path__ + "static/media/survey-mostly-automated.895a0bb264a1d8ed29fbb2d43cbe5aec.svg";
export { ForwardRef as ReactComponent };